/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file scroll-target.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * scroll-target.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Created by keni on 24/07/2017.
 */
// import $ from 'jquery';
import {TweenMax, TweenLite, ScrollToPlugin} from 'gsap';

export function scrollTo(targetWrapper, time, targetElm) {
	let target = $(targetElm);

	// scrollTo($(window), settings.tweenTime, targetId);
	// eslint-disable-next-line no-use-before-define
	// noinspection JSUnresolvedVariable
	TweenMax.to(
		targetWrapper,
		time,
		{
			scrollTo: {
				y: target,
				autoKill: true
			}
		});
}

export function scrollTarget(opt) {
	let settings = {
		tweenTime: 0.2
	};
	let scrollTarget = (function () {
		let settings = {
			tweenTime: 0.2
		};

		function findElement(target) {
			if ($(`#${target}`).length) {
				return $('#' + target);
			}
			if ($(`.${target}`).length) {
				return $('.' + target);
			}
			if ($(target).length) {
				return $(target);
			}
			return null;
		}

		function hasId(target) {
			let id = target.attr('id');

			if (typeof id === typeof undefined || id === false) {
				id = new Date().getTime();
				target.attr('id', id);
			}
			return id;
		}

		function watcher() {
			$('.scroll-next,a').click(function (e) {
				// console.log('test');
				if ($(this).attr('href')) {
					let hash = $(this).attr('href').replace(/^.*?(#|$)/, ''),
						target,
						hasScrollTarget = $(this).attr('data-scroll-target');

					if (hasScrollTarget) {
						target = $(this).attr('data-scroll-target');
					}
					else {
						target = hash;
					}
					if (target !== '') {
						let thisTarget = findElement(target);

						if (thisTarget !== null) {
							e.preventDefault();
							let targetId = '#' + hasId(thisTarget);

							console.log('targetId', targetId);
							// console.log('test','$(window)',$(window), 'settings.tweenTime',settings.tweenTime);
							scrollTo($(window), settings.tweenTime, targetId);
						}
						else {
							window.location = $(this).attr('href');
						}
					}
					else {
						return true;
					}
				}
				return false;
			});
		}

		return {
			init: function (opt) {
				settings = $.extend(settings, opt, {});
				watcher();
			}
		};
	})();

	scrollTarget.init(opt);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/scroll-target.js